import { toJS } from 'mobx';
import { useEffect, useState, useRef } from 'react';
import { useStores } from '../useStore';
import { Status } from 'app-types';
import { useTranslation } from 'react-i18next';
import { useDashboardContext } from 'Pages/Dashboard/DashboardContext';

export function useDownloadReport() {
    const [loading, setLoading] = useState(false);
    const [errorFaced, setErrorFaced] = useState(false);
    const { downloadReportsStore } = useStores();
    const { setToastInfo } = useDashboardContext();
    const { t } = useTranslation();
    const documents = toJS(downloadReportsStore.byDocumentId);

    const processedIds = useRef(new Set<string>());

    useEffect(() => {
        const ids = Object.keys(documents);
        const completed = ids.filter((id) => documents[id].status === Status.Success && !processedIds.current.has(id));

        if (!completed.length) return;

        (async () => {
            setLoading(true);

            try {
                const results = await Promise.all(
                    completed.map(async (id) => {
                        processedIds.current.add(id);
                        const value = downloadReportsStore.byDocumentId[id];
                        const success = !!value.result;
                        if (success) await downloadReportsStore.downloadReportByUUID({ downloadId: id });
                        return { success: !!success };
                    })
                );

                const successCount = results.filter(r => r.success).length;
                setErrorFaced(!successCount);
                let toastInfo : any = { message: t('errorCodes.genericErrorMessage'), type: 'warning' };
                if(successCount) toastInfo = { message: t('dashboard.pdfExport.progress.success.description'), type: 'success', icon: "check" };
                setToastInfo?.(toastInfo);
            } catch {
                setToastInfo?.({ message: t('errorCodes.genericErrorMessage'), type: 'warning' });
            } finally {
                setLoading(false);
            }
        })();
    }, [documents]);

    return { loading, errorFaced };
}